import { render, staticRenderFns } from "./NbaPlayerTrends.vue?vue&type=template&id=fa66d04c&scoped=true"
import script from "./NbaPlayerTrends.vue?vue&type=script&lang=js"
export * from "./NbaPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa66d04c",
  null
  
)

export default component.exports